export const handleSetBackdropLoading = (isLoading) => ({
    type: 'SET_BACKDROP_LOADING', isLoading
});

export const handleChangeBackdropLoadingData = (isLoading, text) => ({
    type: 'CHANGE_BACKDROP_LOADING_DATA', isLoading, text
});